import React, { Component } from 'react';
import { FormattedMessage } from 'ui/i18n';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { authorize } from 'utils/auth';
import { observable, action } from 'mobx';
import { InfoBar, EmptyCartModal, InfoBox, DownloadModal } from 'ui/components';

import './ItemContentHeader.scss';

@inject('AppState', 'CartState', 'CartItemsState')
@observer
export default class ItemContentHeader extends Component {
	static propTypes = {
		AppState: PropTypes.object.isRequired,
		CartState: PropTypes.object.isRequired,
		CartItemsState: PropTypes.object.isRequired,
		children: PropTypes.object.isRequired,
		promotionId: PropTypes.number,
		categoryId: PropTypes.number,
		handleAddToCart: PropTypes.func,
		disableAddToCart: PropTypes.bool,
		printFunctionality: PropTypes.bool,
		name: PropTypes.string,
	};

	static defaultProps = {
		printFunctionality: false,
		handleAddToCart: () => true,
		disableAddToCart: false,
		promotionId: null,
		categoryId: null,
		name: null,
	};

	@action
	componentWillUnMount() {
		this.props.CartState.errorId = '';
	}

	@observable showDownloadModal = false;

	@action
	toggleDownloadModal() {
		this.showDownloadModal = !this.showDownloadModal;
	}

	toggleModal() {
		this.props.CartItemsState.toggleWarningMessage();
	}

	isFranchisee() {
		if (!this.props.AppState.isImpersonated) {
			return authorize(['AddToCart'], true, false);
		}

		return true;
	}

	render() {
		return (
			<div className="ItemContentHeader">
				{!this.isFranchisee() &&
					<div className="nonFranchiseeMessage">
						<FormattedMessage id="item.CannotOrderItems" />
					</div>}

				{this.props.AppState.isOnHoldOrTerminated &&
					<div className="onHoldOrTerminatedMessage">
						<FormattedMessage id="user.onHold" />
					</div>}

				{this.props.CartState.errorId &&
					<InfoBox type="danger">
						<FormattedMessage id={this.props.CartState.errorId} />
					</InfoBox>}

				<InfoBar>
					{this.props.children}

					<div className="col-md-6">
						<button
							id="ItemContentHeader-button-add"
							className="btn btn-primary pull-right"
							disabled={
								this.props.AppState.isOnHoldOrTerminated ||
								this.props.disableAddToCart ||
								!authorize(['AddToCart'], true, false)
							}
							onClick={this.props.handleAddToCart}
						>
							<FormattedMessage id="general.addToCart" />
						</button>
						{this.props.printFunctionality &&
							<button
								id="ItemContentHeader-button-print"
								onClick={this.toggleDownloadModal.bind(this)}
								className="btn btn-secondary pull-right"
							>
								<FormattedMessage id="offeringsPage.print" />
							</button>}
						<DownloadModal
							promotionId={this.props.promotionId}
							categoryId={this.props.categoryId}
							name={this.props.name}
							toggleModal={this.toggleDownloadModal.bind(this)}
							showDownloadModal={this.showDownloadModal}
						/>
					</div>
				</InfoBar>

				<EmptyCartModal
					show={this.props.CartItemsState.toggleWarning}
					onRequestClose={this.toggleModal.bind(this)}
				/>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/ItemContentHeader/index.js